const state = {
	isOpen: false,
	id: null,
	modalTitle: null,
	contsTitle: null,
	params: null,
	data: null,
};

const mutations = {
	toggleModal(state, args) {
		if (args.id) {
			state.id = args.id;
			if (args.contsTitle) state.contsTitle = args.contsTitle;
			state.modalTitle = args.modalTitle;
			state.params = args.params;
			state.data = args.data;
			state.isOpen = true;
		} else {
			state.isOpen = false;
		}
	},
	set(state, args) {
		if (state.hasOwnProperty(args.key)) {
			state[args.key] = args.value;
		}
	},
	init(state) {
		state.isOpen = false;
		state.id = null;
		state.modalTitle = null;
		state.contsTitle = null;
		state.params = null;
	},
};

export default { namespaced: true, state, mutations };
